/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerStore from 'stores/ActionDrawerStore';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from '../../../../ActionDrawer.module.scss';

type InjectedProps = {
  actionDrawerStore: ActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class LoginAsUserError extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  render() {
    const { actionDrawerStore, t } = this.props;
    const errorResponse = actionDrawerStore.errorResponse;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:email_domains.messages.delete_email_domain_failed')}</h3>
            {errorResponse && <p>{actionDrawerStore.errorResponse.message}</p>}
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
